import React from "react";

export function PrivacyStatement() {
  return (
    <div>
      <h5>Child Safety and Privacy Restrictions</h5>
      <p>
        Some countries where we work have child safety and privacy restrictions
        that prevent us from displaying your child&apos;s photo online,
        including on myworldvision.org. This also applies to child videos. For
        these specific countries, we have agreed to share sponsored
        children&apos;s photos only with their individual sponsors and only
        through the mail (such as in your welcome kit or in annual progress
        reports). Out of respect for these countries, and to ensure your
        child&apos;s safety and privacy, we ask that you do not post or share
        any pictures of your sponsored child online in any manner.
      </p>
    </div>
  );
}

export default PrivacyStatement;
